import { DownloadService } from '../utils/downloadService'

export const InspectionApi = {
    downloadPdf: inspectionId => DownloadService.downloadAs(`/web/inspections/${inspectionId}/pdf`, 'technical_report.pdf'),
    downloadExcel: inspectionId => DownloadService.downloadAs(`/web/inspections/${inspectionId}/excel`, 'technical_report.xlsx')
}
